import { createStore } from 'vuex'
import lang from './modules/lang'
import position from './modules/position'

const store = createStore({ /* options */ })

// register a module `myModule`
store.registerModule('lang', lang)
store.registerModule('position', position)

export default store
